import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-research-committee',
  templateUrl: './research-committee.component.html',
  styleUrls: ['./research-committee.component.scss']
})
export class ResearchCommitteeComponent implements OnInit {

  constructor(private seo: SeoService) { }

  ngOnInit(): void {
    this.seo.setMeta('Faculty Research Committee','provide guidance to researchers and investigate all matters pertaining to the research activities of the faculty')
  }

}
